import { useState } from 'owa-react';
import React from 'react';

export enum UserRoles {
    Admin = 'Admin',
    Employee = 'Employee',
}

export interface RoleContextType {
    userRole: UserRoles;
    setUserRole: (role: UserRoles) => void;
}

export const RoleContext: React.Context<RoleContextType> = React.createContext<RoleContextType>({
    userRole: UserRoles.Admin,
    setUserRole: () => {},
});

export const useRoleContext = (): RoleContextType => {
    return React.useContext(RoleContext);
};

export interface RoleContextProviderProps {
    children: React.ReactNode;
}
export default function RoleContextProvider({ children }: RoleContextProviderProps): JSX.Element {
    const [userRole, setUserRole] = useState(UserRoles.Admin);

    const contextValue = React.useMemo(
        () => ({
            userRole,
            /* eslint-disable-next-line owa-custom-rules/no-unused-react-set-state -- (https://aka.ms/OWALintWiki)
             * DO NOT COPY-PASTE!, add a justification or fix the issue
             *	> React setState functions from useState should only be used by direct invocation, setState(), not passed or used as a value or used in hook's array dependencies.
             *	> React setState functions from useState should only be used by direct invocation, setState(), not passed or used as a value or used in hook's array dependencies. */
            setUserRole,
        }),
        /* eslint-disable-next-line owa-custom-rules/no-unused-react-set-state -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, add a justification or fix the issue
         *	> React setState functions from useState should only be used by direct invocation, setState(), not passed or used as a value or used in hook's array dependencies. */
        [userRole, setUserRole]
    );

    return <RoleContext.Provider value={contextValue}>{children}</RoleContext.Provider>;
}
